export default {
  getStages: state => state.items,
}
